class TrudoorStickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleAddToCart = this.handleAddToCart.bind(this);
  }

  connectedCallback() {
    this.variationsForm = document.querySelector("form.variations_form #add");
    this.headerHeight = document.querySelector("header").offsetHeight;
    this.addToCartButton = this.querySelector("#sticky-add-to-cart-button");

    // Set up event listeners
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleResize);

    if (this.addToCartButton) {
      if (this.addToCartButton.classList.contains("variations")) {
        this.addToCartButton.addEventListener("click", () => {
          this.stickyUp();
          window.scrollTo({ top: 0, behavior: "smooth" });
        });
      } else {
        this.addToCartButton.addEventListener("click", this.handleAddToCart);
      }
    }
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
    this.addToCartButton?.removeEventListener("click", this.handleAddToCart);
  }

  handleScroll() {
    if (!this.variationsForm) return;
    const formRect = this.variationsForm.getBoundingClientRect();

    setTimeout(() => {
      if (formRect.top < 0) {
        if (this.isElementInViewport(this.variationsForm)) {
          this.stickyUp();
        } else {
          this.stickyDown();
        }
      } else {
        this.stickyReset();
      }
    }, 200);
  }

  handleResize() {
    this.headerHeight = document.querySelector("header").offsetHeight;
  }

  async handleAddToCart() {
    const variantId = this.addToCartButton.dataset.productId;
    const sku = this.addToCartButton.dataset.productSku;
    const shipsIn = this.addToCartButton.dataset.productShips;

    const properties = shipsIn ? { SKU: sku, "Usually Ships": shipsIn } : { SKU: sku };

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties,
        }),
      });

      const result = await response.json();

      if (!response.ok) throw new Error(result.description);

      // Show success state
      this.addToCartButton.classList.add("added");
      setTimeout(() => this.addToCartButton.classList.remove("added"), 2000);

      // Dispatch events for cart updates
      document.dispatchEvent(
        new CustomEvent("cart:update", {
          detail: { newItems: [result] },
        }),
      );
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    } catch (error) {
      console.error("Failed to add item to cart:", error);
      // Could dispatch an error event here if needed
    }
  }

  isElementInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  stickyDown() {
    this.classList.add("storefront-sticky-add-to-cart--slideInDown");
    this.classList.remove("storefront-sticky-add-to-cart--slideOutUp");
    this.style.top = `${this.headerHeight}px`;
  }

  stickyUp() {
    this.classList.add("storefront-sticky-add-to-cart--slideOutUp");
    this.classList.remove("storefront-sticky-add-to-cart--slideInDown");
    this.style.top = "0";
  }

  stickyReset() {
    this.classList.remove("storefront-sticky-add-to-cart--slideOutUp");
    this.classList.remove("storefront-sticky-add-to-cart--slideInDown");
    this.style.top = "0";
  }
}

customElements.define("trudoor-sticky-add-to-cart", TrudoorStickyAddToCart);
